import { EMPTY_LIST } from '../../../../constants/common'
import { Checkbox, CHECKBOX_TYPE } from '../../../Checkbox'
import { Control } from '../Control'

import { getOptionLabel } from './ControlRadioGroup.utils'

import * as styles from './ControlRadioGroup.module.css'

export function ControlRadioGroup({
  getLabel = getOptionLabel,
  options = EMPTY_LIST,
  value,
  onChange,
  ...controlProps
}) {
  function handleOptionChange(option, checked) {
    const nextValue = checked
      ? option
      : Object.is(option, value.value)
        ? undefined
        : value.value

    onChange(value, { value: nextValue })
  }

  return options ? (
    <Control {...controlProps} value={value} onChange={onChange}>
      <div className={styles.options}>
        {[...options].map((option, index) => (
          <Checkbox
            checked={Object.is(option, value.value)}
            disabled={value.omitted}
            key={index}
            label={getLabel(option)}
            size='small'
            type={CHECKBOX_TYPE.rounded}
            onChange={checked => handleOptionChange(option, checked)}
          />
        ))}
      </div>
    </Control>
  ) : null
}

export default ControlRadioGroup
